module.exports = __webpack_public_path__ + "static/media/nav-icon4.adf5bffc.svg";